module.exports = {
  "pageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "page_type": {
        "type": "string",
        "isOptional": true
      },
      "screen": [
        "detail"
      ],
      "subscreen": [
        "personalization",
        "personalization-results",
        "performance",
        "optimization",
        "smart-content",
        "variations"
      ]
    },
    "namespace": "content-detail-ui"
  },
  "exploreReport": {
    "name": "Explore Report",
    "class": "interaction",
    "properties": {
      "date_range": {
        "type": "string",
        "isOptional": true
      },
      "page_type": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "changed-date-range",
        "clicked-tab"
      ],
      "screen": [
        "detail"
      ],
      "subscreen": [
        "optimization",
        "performance",
        "smart-content",
        "testResults",
        "variations"
      ]
    },
    "namespace": "content-detail-ui"
  },
  "contentOptimizationInteraction": {
    "name": "content-optimization-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "seo",
        "queries",
        "inboundLinks",
        "internalLinks"
      ]
    },
    "namespace": "content-detail-ui"
  },
  "contentActionsInteraction": {
    "name": "content-actions-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "archive",
        "archive-and-unpublish",
        "attachToLanguageMaster",
        "changeAudienceAccess",
        "chooseVariationWinner",
        "clone",
        "convert-type",
        "create-ad-campaign",
        "create-and-use-in-list",
        "createTranslationVariation",
        "createVariation",
        "delete",
        "edit",
        "exportPeople",
        "publish",
        "rename",
        "rerunVariation",
        "run-a-test",
        "share",
        "unarchive",
        "unpublish",
        "useInList",
        "view",
        "removeFromLanguageGroup"
      ],
      "newContentType": {
        "isOptional": true,
        "type": [
          "BLOG_POST",
          "EXTERNAL_PAGE",
          "LANDING_PAGE",
          "SITE_PAGE",
          "BLOG_LISTING_PAGE"
        ]
      },
      "page-type": [
        "BLOG_POST",
        "EXTERNAL_PAGE",
        "LANDING_PAGE",
        "SITE_PAGE",
        "BLOG_LISTING_PAGE"
      ],
      "status": [
        "success",
        "fail"
      ],
      "screen": [
        "detail"
      ],
      "subscreen": {
        "isOptional": true,
        "type": [
          "performance",
          "optimization",
          "personalization-results"
        ]
      }
    },
    "namespace": "content-detail-ui"
  },
  "mabInteraction": {
    "name": "mab-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-end-test-button",
        "end-test"
      ],
      "page-type": [
        "LANDING_PAGE",
        "SITE_PAGE"
      ],
      "status": [
        "success",
        "fail"
      ]
    },
    "namespace": "content-detail-ui"
  },
  "adsPanelInteraction": {
    "name": "ads-panel-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-ads-onboarding-link",
        "clicked-settings-url",
        "clicked-create-website-traffic-ad"
      ],
      "network": [
        "FACEBOOK",
        "LINKEDIN",
        "ADWORDS",
        "NONE"
      ]
    },
    "namespace": "content-detail-ui"
  },
  "videoReportInteraction": {
    "name": "report interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": false
      }
    },
    "namespace": "video-reports",
    "version": "1"
  },
  "contentLabelLibInteraction": {
    "name": "content label lib interaction",
    "class": "interaction",
    "properties": {
      "wordpress_plugin": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": [
          "warning-tag-loaded",
          "open-close-modal-click",
          "info-modal-loaded",
          "details-banner-loaded"
        ]
      }
    },
    "namespace": "content-label-lib"
  },
  "contentLabelLibInteractionPages": {
    "name": "content label lib interaction",
    "class": "interaction",
    "properties": {
      "wordpress_plugin": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": [
          "warning-tag-loaded",
          "open-close-modal-click",
          "info-modal-loaded",
          "details-banner-loaded"
        ]
      }
    },
    "namespace": "content-label-lib"
  },
  "blogQuickCreateModalOpened": {
    "name": "blog quick create modal action",
    "class": "interaction",
    "namespace": "content-components"
  },
  "blogQuickCreateModalClickedCreate": {
    "name": "blog quick create modal action",
    "class": "interaction",
    "namespace": "content-components"
  },
  "audienceAccessInteraction": {
    "name": "audience access interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "click-radio-all",
          "click-radio-password",
          "click-radio-sso",
          "click-radio-specificContacts",
          "click-radio-ssoWithSpecificContacts",
          "show-password-help",
          "show-sso-help",
          "show-specificContacts-help",
          "show-ssoWithSpecificContacts-help",
          "change-lists",
          "click-kb-article",
          "show-sso-disabled-tooltip",
          "show-registration-disabled-tooltip"
        ]
      }
    },
    "namespace": "content-components"
  },
  "partnerMatchingAppInteraction": {
    "name": "partner matching app interaction",
    "namespace": "partner-matching-app",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string"
      },
      "app": {
        "type": "string"
      }
    }
  },
  "colorImportInteraction": {
    "name": "color import modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "submit-url",
          "website-colors-retrieved",
          "toggle-color-selection",
          "import-colors"
        ]
      }
    },
    "namespace": "content-components"
  },
  "setupCustomDomainModalInteraction": {
    "name": "setup custom domain modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "view",
          "clicked-add-custom-domain-button"
        ]
      },
      "screen": [
        "detail"
      ]
    },
    "namespace": "content-components"
  },
  "ContentComponentsInteraction": {
    "name": "ContentComponents interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "custom-fonts-upload-modal-opened",
          "custom-fonts-upload-modal-closed",
          "custom-fonts-create-font",
          "custom-fonts-edit-font",
          "custom-fonts-delete-font"
        ]
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionUsage": {
    "name": "content-create-autotranslation-action",
    "class": "usage",
    "properties": {
      "action": [
        "create-multi-language-variation",
        "direct-translate"
      ],
      "status": [
        "success",
        "fail"
      ],
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionActivation": {
    "name": "content-create-autotranslation-action",
    "class": "activation",
    "properties": {
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionInteraction": {
    "name": "content-create-autotranslation-action",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-submit-create-multi-language-variation",
        "clicked-ai-translate-toggle"
      ],
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      },
      "isAutoTranslateEnabled": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  }
};